export const PATHS = {
  documentVerification: '/document-verifications/',
  file: '/file-url/',
  reportVerification: '/report-verification/',
  externalReport: '/shared-report/',
};
